module.exports = {
  GOOGLE: 'google',
  OUTLOOK: 'outlook',
};
